import moment from 'moment';
import LoaderPopover from '@/components/loaderpopover_component.vue';
export default {
    name: 'bookings',
    components: {
        LoaderPopover
    },
    data() {
        return {   
            salons : [],
            selected_date:moment(new Date()).format('MMM D, YYYY'),
            today_bookings_data:{},
            bookings:{},
            salon_selected:null,
            windowHeight : window.innerHeight - 500,
        }
    },
    mounted() {
        if(this.$session.has('selected_booking_date')){
            this.selected_date = moment(this.$session.get('selected_booking_date')).format('MMM D, YYYY');
            this.$session.remove('selected_booking_date')
        }
        this.getStore();
    },
    created() {
        window.addEventListener("resize", this.onResize);
    },
    destroyed(){
        window.removeEventListener("resize", this.onResize);
    },
    methods: {
        onResize(){
            this.windowHeight = window.innerHeight - 500;
        },
        get_current_date(){
            var date =  moment(new Date(),"DD-MM-YYYY").format('MMM D, YYYY');
            this.selected_date = date;
            this.get_bookings();
        },
        get_previous_date(){  
            var previous_date = moment(this.selected_date).add(-1, 'days').format('MMM D, YYYY');
            this.selected_date = previous_date;
            this.get_bookings();
        },
        get_next_date(){
            var next_date = moment(this.selected_date).add(1, 'days').format('MMM D, YYYY');
            this.selected_date = next_date;
            this.get_bookings();
        },

        picker_selected_date(ctx){
            var date = moment(ctx).format('MMM D, YYYY');
            this.selected_date = date;
            this.get_bookings();
        },
                
        async getStore(){
            await this.$store.dispatch('getStoreByOwnerId',[this.$store.state.api,this.$store.state.user_id]);
            if(Object.keys(this.$store.state.stores_data).length > 0){
                this.salons = this.$store.state.stores_data; 
            }
            this.salon_selected =  this.$store.state.stores_data[0].store_id;
            this.get_bookings();
        },
        async get_bookings(){
            this.$store.state.loader_popup = true
            this.bookings = [];
            this.today_bookings_data.store_id = this.salon_selected;
            if(this.selected_date){
                this.today_bookings_data.start_date = moment(this.selected_date, 'MMM D, YYYY').format("YYYY-MM-DD");
                this.today_bookings_data.end_date = moment(this.selected_date).add(1, 'days').format("YYYY-MM-DD");
            }
            await this.$store.dispatch('staffwise_bookings',[this.$store.state.api,this.today_bookings_data]);
            if(Object.keys(this.$store.state.staff_wise_bookings.staffwise_bookings).length > 0){
                let all_bookings = this.$store.state.staff_wise_bookings.staffwise_bookings[0];
                for (let j = 0; j < all_bookings.staff.length; j++){
                    for (let k = 0; k < all_bookings.staff[j].bookings.length; k++){
                        if(all_bookings.staff[j].bookings[k].service_name != 'Break'){
                            this.bookings.push(all_bookings.staff[j].bookings[k])
                        }
                    }
                }

            }
            this.$store.state.loader_popup = false
        },
        open_view_booking(book_id,multi_bookid){ 
            this.$session.set('book_id',book_id);
            this.$session.set('multi_book_id',multi_bookid)
            this.$router.push('/mobileviewbooking')
        }  
    },
    filters:{
        time_format(time){
            return moment(time , 'YYYY-MM-DD HH:mm:ss').format("hh:mm A");
        },
    }
}